/** Build-time configuration (Vite env). See web/AGENTS.md. */
const env = import.meta.env;

export const config = {
  /** API origin; empty = same origin (dev: Vite proxies /v1 to the local Go server). */
  apiBaseUrl: ((env.VITE_API_BASE_URL as string | undefined) ?? '').replace(/\/+$/, ''),
  supabaseUrl: (env.VITE_SUPABASE_URL as string | undefined) ?? '',
  supabaseAnonKey: (env.VITE_SUPABASE_ANON_KEY as string | undefined) ?? '',
  /** Local dev only: sign in with an HS256 token signed by the server's AUTH_DEV_SECRET. */
  devAuth: env.VITE_DEV_AUTH === '1',
  devAuthSecret: (env.VITE_DEV_AUTH_SECRET as string | undefined) ?? '',
  /** Support address shown on public pages (/delete-account). Placeholder until set at build time. */
  supportEmail: (env.VITE_SUPPORT_EMAIL as string | undefined) || '<SUPPORT_EMAIL>',
  /** Cloudflare Turnstile sitekey for the no-card trial. Dev default: Cloudflare's always-pass test key. */
  turnstileSiteKey:
    (env.VITE_TURNSTILE_SITEKEY as string | undefined) ?? (import.meta.env.DEV ? '1x00000000000000000000AA' : ''),
  /**
   * Sign-in buttons for the Supabase OAuth providers that are set up (VITE_OAUTH_PROVIDERS,
   * comma-separated: "apple,google"). Unset = both; empty = email codes only.
   */
  oauthProviders: ((env.VITE_OAUTH_PROVIDERS as string | undefined) ?? 'apple,google')
    .split(',')
    .map((p) => p.trim())
    .filter((p): p is 'apple' | 'google' => p === 'apple' || p === 'google'),
};

export const supabaseConfigured = () => !!(config.supabaseUrl && config.supabaseAnonKey);
